import { ref, watchEffect } from 'vue';

const STORAGE_KEY = 'indicoo-theme';
const storedTheme = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;

const theme = ref(storedTheme === 'light' || storedTheme === 'dark' ? storedTheme : 'dark');

watchEffect(() => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme.value);
  window.localStorage.setItem(STORAGE_KEY, theme.value);
});

export default function useTheme() {
  const toggleTheme = () => {
    theme.value = theme.value === 'dark' ? 'light' : 'dark';
  };

  const setTheme = (value) => {
    theme.value = value === 'light' ? 'light' : 'dark';
  };

  return {
    theme,
    toggleTheme,
    setTheme,
  };
}
